var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0ZM4.32061 7.45419H6.3602V13.5823H4.32061V7.45419ZM6.49454 5.55851C6.4813 4.95765 6.05162 4.5 5.35389 4.5C4.65615 4.5 4.2 4.95765 4.2 5.55851C4.2 6.14693 4.64267 6.61776 5.32741 6.61776H5.34045C6.05162 6.61776 6.49454 6.14693 6.49454 5.55851ZM11.3674 7.31029C12.7096 7.31029 13.7158 8.18635 13.7158 10.0686L13.7157 13.5823H11.6762V10.3038C11.6762 9.48027 11.381 8.91834 10.6427 8.91834C10.0792 8.91834 9.74358 9.29716 9.59617 9.66306C9.54224 9.79419 9.529 9.97689 9.529 10.16V13.5825H7.48916C7.48916 13.5825 7.51605 8.02939 7.48916 7.45436H9.529V8.32236C9.79971 7.90509 10.2845 7.31029 11.3674 7.31029Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinWhite);
export default __webpack_public_path__ + "static/media/linkedin-white.554a15ab442b1adbd143b3bc0c3e804c.svg";
export { ForwardRef as ReactComponent };